<script>
import Banner from 'dashboard/components/ui/Banner.vue';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { LocalStorage } from 'shared/helpers/localStorage';
import { mapGetters } from 'vuex';
import {
  hasDeferredInstallPrompt,
  promptInstall,
  isRunningStandalone,
} from '../../helper/pwaInstallHelper';

export default {
  components: { Banner },
  data() {
    return {
      showBanner: false,
      userDismissedBanner: false,
    };
  },
  computed: {
    ...mapGetters({ globalConfig: 'globalConfig/get' }),
    shouldShowBanner() {
      return (
        this.showBanner &&
        this.globalConfig.displayManifest &&
        !this.userDismissedBanner
      );
    },
  },
  mounted() {
    if (isRunningStandalone() || this.isInstallDismissed()) return;

    window.addEventListener('pwa-install-available', this.onInstallAvailable);
    window.addEventListener('pwa-install-completed', this.onInstallCompleted);

    if (hasDeferredInstallPrompt()) {
      this.showBanner = true;
    }
  },
  unmounted() {
    window.removeEventListener(
      'pwa-install-available',
      this.onInstallAvailable
    );
    window.removeEventListener(
      'pwa-install-completed',
      this.onInstallCompleted
    );
  },
  methods: {
    isInstallDismissed() {
      return !!LocalStorage.get(LOCAL_STORAGE_KEYS.PWA_INSTALL_DISMISSED);
    },
    onInstallAvailable() {
      if (!this.isInstallDismissed()) {
        this.showBanner = true;
      }
    },
    onInstallCompleted() {
      this.showBanner = false;
      LocalStorage.remove(LOCAL_STORAGE_KEYS.PWA_INSTALL_DISMISSED);
    },
    async onInstall() {
      await promptInstall();
      this.showBanner = false;
    },
    onDismiss() {
      LocalStorage.set(LOCAL_STORAGE_KEYS.PWA_INSTALL_DISMISSED, Date.now());
      this.userDismissedBanner = true;
    },
  },
};
</script>

<template>
  <Banner
    v-if="shouldShowBanner"
    color-scheme="primary"
    :banner-message="$t('GENERAL_SETTINGS.PWA_INSTALL.AVAILABLE')"
    has-action-button
    :action-button-label="$t('GENERAL_SETTINGS.PWA_INSTALL.INSTALL')"
    action-button-icon="i-lucide-download"
    has-close-button
    @primary-action="onInstall"
    @close="onDismiss"
  />
</template>
